import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.scss';

const Loader = ({ size, shade, contentBlock, top, hide, animate, fadeOut }) => {
    const loaderClass = classNames({
        [styles.spinner]: true,
        [styles.spinner_small]: size === 'small',
        [styles.spinner_medium]: size === 'medium',
        [styles.spinnerTop]: top,
    });

    const warapperClass = classNames({
        [styles.loaderWrapper]: true,
        [styles.shade]: shade,
        [styles.inline]: !shade,
        [styles.contentBlock]: contentBlock,
        [styles.hide]: hide,
        [styles.animate]: animate,
        [styles.fadeOut]: fadeOut,
    });

    return (
        <div className={warapperClass}>
            <div className={loaderClass} />
        </div>
    );
};

Loader.propTypes = {
    size: PropTypes.string,
    shade: PropTypes.bool,
    contentBlock: PropTypes.bool,
    top: PropTypes.bool,
    hide: PropTypes.bool,
    animate: PropTypes.bool,
    fadeOut: PropTypes.bool,
};

Loader.defaultProps = {
    size: 'large',
    shade: true,
    contentBlock: false,
};

export default Loader;
